import React from "react"
import { Box, BoxProps } from "@chakra-ui/core"
import { FormProvider } from "react-hook-form"
import FormBox from "../common/FormBox"
import FormTitle from "../common/FormTitle"
import FormDescription from "../common/FormDescription"
import FormFieldsLayout from "../common/FormFieldsLayout"
import { ConnectedTextField as TextField } from "../../FormFields/TextField"
import { ConnectedDateField as DateField } from "../../FormFields/DateField"
import FormSubtitle from "../common/FormSubtitle"
import Body from "../../typography/Body"
import TextAreaField from "../../FormFields/TextAreaField"
import { Button } from "../../Buttons"
import StoreSelectField from "../common/StoreSelectField"
import useGoogleForm from "../../../hooks/useGoogleForm"
import config from "../../../config"
import SuccessWrapper from "./SuccessWrapper"

type MissingItemFormProps = BoxProps & {}

export default function MissingItemForm({ ...props }: MissingItemFormProps) {
  const { methods, onSubmit, isSubmitting, success, error } = useGoogleForm<{}>(
    {
      sheetsId: config.GATSBY_MISSING_BIKE_GOOGLE_SHEETS_ID,
    }
  )

  return (
    <FormProvider {...methods}>
      <FormBox {...props} onSubmit={methods.handleSubmit(onSubmit)}>
        <SuccessWrapper success={success}>
          <FormTitle>Missing Item</FormTitle>
          <FormDescription>
            We&apos;re sorry to hear you didn&apos;t get your entire order.
            We&apos;d love the chance to make this right.
            <br />
            <br />
            We have a larger amount of inquires than normal and we&apos;re
            working through the requests as quickly as possible. We appreciate
            your patience.
            <br />
            <br />
            Please complete the form below and our team will be notified
            you&apos;re in the queue to be helped.
          </FormDescription>
          <FormFieldsLayout mb="2.9531rem">
            <TextField name="Name on order" placeholder="Name on Order" />
            <TextField
              name="Email Address"
              placeholder="Email address"
              type="email"
            />
            <DateField name="Order Date" placeholder="Order Date" isRequired />
            <StoreSelectField />
            <TextField
              name="Order number"
              placeholder="Order Number"
              isRequired
            />
          </FormFieldsLayout>
          <FormSubtitle mb="0.5rem">
            What item(s) did you not receive?
          </FormSubtitle>
          <Body size="sm" color="dusk" mb="0.5rem">
            Please enter bike name(s) or SKU(s) below:
          </Body>
          <TextField
            name="What item(s) did you not receive?"
            placeholder="Bike name(s) or SKU(s)"
            mb="1.0856rem"
          />
          <TextAreaField
            name="Additional Comments:"
            placeholder="Additional comments"
          />
          <Box textAlign="center" mt="4.32rem">
            <Button theme="primary" type="submit" isLoading={isSubmitting}>
              Submit
            </Button>
          </Box>
          {error && (
            <Body mt="2rem" color="sunrise">
              {error}
            </Body>
          )}
        </SuccessWrapper>
      </FormBox>
    </FormProvider>
  )
}
